// src/pages/Admin/Orders/components/OrderStatusBadge.tsx
import React from 'react';
import { Clock, Package, Truck, CheckCircle, XCircle, AlertCircle } from 'lucide-react';

interface OrderStatusBadgeProps {
  status: string;
  size?: 'sm' | 'md';
}

const OrderStatusBadge: React.FC<OrderStatusBadgeProps> = ({ status, size = 'md' }) => {
  const configs: Record<string, { color: string; bg: string; icon: React.ElementType; label: string }> = {
    confirmed: { 
      color: 'text-blue-700', 
      bg: 'bg-blue-50', 
      icon: Clock, 
      label: 'Confirmed' 
    },
    processing: { 
      color: 'text-yellow-700', 
      bg: 'bg-yellow-50', 
      icon: Package, 
      label: 'Processing' 
    },
    packed: { 
      color: 'text-purple-700', 
      bg: 'bg-purple-50', 
      icon: Package, 
      label: 'Packed' 
    },
    out_for_delivery: { 
      color: 'text-indigo-700', 
      bg: 'bg-indigo-50', 
      icon: Truck, 
      label: 'Out for Delivery' 
    },
    delivered: { 
      color: 'text-green-700', 
      bg: 'bg-green-50', 
      icon: CheckCircle, 
      label: 'Delivered' 
    },
    cancelled: { 
      color: 'text-red-700', 
      bg: 'bg-red-50', 
      icon: XCircle, 
      label: 'Cancelled' 
    },
  };

  const config = configs[status] || configs.confirmed;
  const Icon = config.icon;

  const sizeClasses = size === 'sm' 
    ? 'px-2 py-0.5 text-xs gap-1' 
    : 'px-2.5 py-1 text-sm gap-1.5';

  return (
    <span className={`inline-flex items-center rounded-full font-medium ${config.bg} ${config.color} ${sizeClasses}`}>
      <Icon className={size === 'sm' ? 'w-3 h-3' : 'w-3.5 h-3.5'} />
      {config.label}
    </span>
  );
};

export default OrderStatusBadge;